'use strict';

var HTMLProjectionNode = require('../../projection/node/HTMLProjectionNode.cjs');
var MeasureLayout = require('./layout/MeasureLayout.cjs');

const layout = {
    layout: {
        ProjectionNode: HTMLProjectionNode.HTMLProjectionNode,
        MeasureLayout: MeasureLayout.MeasureLayout,
    },
};

exports.layout = layout;
//# sourceMappingURL=layout.cjs.map
